<template>
  <div>
    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px">
      <el-table-column
          v-for="(it, index) in tableFeildAndVal"
          :key="index"
          :label="it.lable"
          :prop="it.key"
          min-width="15%" align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getAdminOrderVoList} from "../../api/b2cbusiness/b2c_orderlist";
export default {
  name: "DoItOrderComponent",
  mixins:[MixinCUD],
  props:["tableFeildAndVal", "orderCondition"],
  data() {
    return {
      tableData:[
        {
          orderTime: "2021/6/16 12:00:00",
          orderId: "321212112121",
          userId: "3212121434341",
          orderInfo: "我是慈姐 \n" +
              "\n" +
              "1877407707447192952\n",
          priceInfo: "押金：318.00 \n" +
              "\n" +
              "服务费：11.00 \n",
          orderStatus: "确认发货返款",
        }
      ],
    }
  },
  mounted() {
    this.getData();
  },
  watch:{
    orderCondition(newVal, oldVal){
      console.log(oldVal, newVal);
      getAdminOrderVoList({taskId:newVal.taskId, status:newVal.status}, {pageNum:1, pageSize:10}).then(res=>{
        if (res.success){
          console.log(res.data)
          this.tableData = res.data.records;
        }
      });
    }
  },
  computed:{
  },
  methods: {
    getData(){
      getAdminOrderVoList({taskId:this.orderCondition.taskId, status:this.orderCondition.status}, {pageNum:1, pageSize:10}).then(res=>{
        if (res.success){
          console.log(res.data)
          this.tableData = res.data.records;
        }
      });
    }
  },
}
</script>

<style scoped>

</style>
